import createApp from './app.js'

import authService from './service.auth.js'
import databaseService from './service.database.js'
import storageService from './service.storage.js'
import functionsService from './service.functions.js'
import messagingService from './service.messaging.js'
import performanceService from './service.performance.js'
import analyticsService from './service.analytics.js'

const appConfig = {"apiKey":"AIzaSyAUoUsLdIEeaVGMRgsuTVyQxr2SAxW_kfg","authDomain":"immersive-language-lab.firebaseapp.com","databaseURL":"https:\u002F\u002Fimmersive-language-lab.firebaseio.com","projectId":"immersive-language-lab","storageBucket":"immersive-language-lab.appspot.com","messagingSenderId":"1001158521314","appId":"1:1001158521314:web:d20cd738f1b9d341","measurementId":"G-5HE5VKL4DY"}

export default async (ctx, inject) => {
  const { firebase, session } = await createApp(appConfig, ctx)

  let servicePromises = []

  if (process.server) {
    servicePromises = [
      authService(session, firebase, ctx, inject),
    databaseService(session, firebase, ctx, inject),
    storageService(session, firebase, ctx, inject),
    functionsService(session, firebase, ctx, inject),

    ]
  }

  if (process.client) {
    servicePromises = [
      authService(session, firebase, ctx, inject),
      databaseService(session, firebase, ctx, inject),
      storageService(session, firebase, ctx, inject),
      functionsService(session, firebase, ctx, inject),
      messagingService(session, firebase, ctx, inject),
      performanceService(session, firebase, ctx, inject),
      analyticsService(session, firebase, ctx, inject),

    ]
  }

  const [
    auth,
    database,
    storage,
    functions,
    messaging,
    performance,
    analytics
  ] = await Promise.all(servicePromises)

  const fire = {
    auth: auth,
    database: database,
    storage: storage,
    functions: functions,
    messaging: messaging,
    performance: performance,
    analytics: analytics
  }

    inject('fireModule', firebase)
    ctx.$fireModule = firebase

  inject('fire', fire)
  ctx.$fire = fire
}

function forceInject (ctx, inject, key, value) {
  inject(key, value)
  const injectKey = '$' + key
  ctx[injectKey] = value
  if (typeof window !== "undefined" && window.$nuxt) {
  // If clause makes sure it's only run when ready() is called in a component, not in a plugin.
    window.$nuxt.$options[injectKey] = value
  }
}